import { defineMessages } from 'react-intl';

const messages = defineMessages({
    collaboratorAvatarsLabel: {
        defaultMessage: 'Shared with',
        description: 'Label for collaborator avatars',
        id: 'boxui.collaboratorAvatars.collaboratorAvatarsLabel',
    },
    expirationTooltipText: {
        defaultMessage: 'Access expires on {date}',
        description: 'Tooltip text for collaborator expiration badge',
        id: 'boxui.collaboratorAvatars.collaborators.expirationTooltipText',
    },
    externalCollabTooltipText: {
        defaultMessage: '{email} is from outside of your company',
        description: 'This tooltip indicates that a collaborator is not in the same enterprise of the current user',
        id: 'boxui.collaboratorAvatars.collaborators.externalCollabTooltipText',
    },
    manageAllLinkText: {
        defaultMessage: 'Manage All',
        description: 'Manage all link text on collaborator list',
        id: 'boxui.collaboratorAvatars.manageAllLinkText',
    },
    pendingCollabText: {
        defaultMessage: 'Pending',
        description: 'Text to display for users who have not accepted an invitation to collaborate yet',
        id: 'boxui.collaboratorAvatars.collaboration.pendingCollabText',
    },
    viewAdditionalPeopleText: {
        defaultMessage: 'View additional people',
        description: 'Text to display in collaborator list if there are more items',
        id: 'boxui.collaboratorAvatars.viewAdditionalPeopleText',
    },
});

export default messages;
